
export const INITIAL_BREADTH = 15.5; 
export const INITIAL_HEIGHT = 300; 
export const SNAPPING_THRESHOLD = 15;
